module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-04.68afcd74.jpg";